import React, { FunctionComponent, MouseEvent } from 'react';
import './chat-popup.scss';
import ActionButton from './../../shared/action-button/action-button';

interface IChatPopupHeader {
    onClose: () => void;
    handleMouseDown: (e: MouseEvent<HTMLDivElement>) => void;
    messagesCount: number;
    isMobile: boolean;
}

const MobileHeader: FunctionComponent<Pick<IChatPopupHeader, 'messagesCount'>> = ({ messagesCount }): JSX.Element => {
  return (
    <>
      <div className='chat-box-header__icon'/>
      <b>Messages</b> ({messagesCount})
    </>
  );
};

const DesctopHeader: FunctionComponent<Pick<IChatPopupHeader, 'handleMouseDown'>> = ({ handleMouseDown }): JSX.Element => {
  return (
    <div className='chat-box-resizer' onMouseDown={handleMouseDown}/>
  );
};


const ChatPopupHeader: FunctionComponent<IChatPopupHeader> = ({ onClose, handleMouseDown, messagesCount, isMobile }) => {
  return (
    <>
      <div className='chat-box-header'>
        {isMobile
          ? <MobileHeader messagesCount={messagesCount}/>
          : <DesctopHeader handleMouseDown={handleMouseDown}/>
        }
      </div>
      <ActionButton customClasses='chat-box-close-button close-icon' onClick={onClose}/>
    </>
  );
};

export default ChatPopupHeader;
